import type { ReactNode } from "react";
import { Link } from "react-router-dom";

export const TONES: Record<string, { bg: string; fg: string }> = {
  blue: { bg: "#e8f0ff", fg: "#2f6fed" },
  green: { bg: "#e6f7ec", fg: "#1f9d55" },
  orange: { bg: "#fff4e5", fg: "#d98c1f" },
  red: { bg: "#fdecec", fg: "#d64545" },
  violet: { bg: "#f1ebff", fg: "#7c3aed" },
  gray: { bg: "#f1f3f7", fg: "#4b5563" },
};

export interface MetricProps {
  title: string;
  value: number | string;
  to: string;
  icon: ReactNode;
  tone?: keyof typeof TONES;
  suffix?: string;
  hint?: string;
  op?: "receive" | "ship";
}

/**
 * A number of the desktop that opens its list. `op`: a tile of documents takes the colour of their operation
 * (поступления зелёные, заказы на отгрузку синие). ТЗ «Рабочие столы» 31.10.2026 (UXW-18): the page of HEAD and the
 * widgets of the personal desktop draw this very tile.
 */
export function MetricTile({ title, value, to, icon, tone = "blue", suffix, hint, op }: MetricProps) {
  const t = TONES[tone];
  return (
    <Link to={to} className={op ? `wms-metric wms-metric-${op}` : "wms-metric"} title={hint}>
      <span className="wms-metric-icon" style={op ? undefined : { background: t.bg, color: t.fg }}>
        {icon}
      </span>
      <div className="wms-metric-value">
        {value}
        {suffix && <span style={{ fontSize: 13, fontWeight: 400, color: "var(--wms-muted)", marginLeft: 6 }}>{suffix}</span>}
      </div>
      <div className="wms-metric-title">{title}</div>
    </Link>
  );
}
